/**
 * @generated SignedSource<<76a8ef1f7d3118fe531107895733d2c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ItemPickerLabelItem$data = {
  readonly color: string;
  readonly description: string | null | undefined;
  readonly id: string;
  readonly name: string;
  readonly nameHTML: string;
  readonly url: string;
  readonly " $fragmentType": "ItemPickerLabelItem";
};
export type ItemPickerLabelItem$key = {
  readonly " $data"?: ItemPickerLabelItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"ItemPickerLabelItem">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ItemPickerLabelItem"
};

(node as any).hash = "b2fc01bc82fb5dfef04abcdb0582e34c";

export default node;
